import { Component, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import {
  ImageCroppedEvent,
  ImageCropperComponent,
  LoadedImage,
} from 'ngx-image-cropper';
import { UserEntity } from 'src/app/models/entities/user.entity';

@Component({
    selector: 'app-profile-edit',
    templateUrl: './profile-edit.component.html',
    styleUrls: ['./profile-edit.component.scss'],
    standalone: false
})
export class ProfileEditComponent {
  @ViewChild('cropper') cropper!: ImageCropperComponent;

  imageChangedEvent: any = '';
  croppedImage: any = '';
  fileSelected: boolean = false;
  imageFileType: string = '';

  constructor(
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<ProfileEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UserEntity
  ) {}

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.fileSelected = true;
    this.imageFileType = event.target.files[0].name.split('.').pop() || '';
  }
  imageCropped(event: ImageCroppedEvent) {
    
    if (event && event.objectUrl) {
      this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(
        event.objectUrl
      );

      this.dialogRef.close({
        image: event.blob,
        type: this.imageFileType,
        preview:  this.croppedImage 
      });
      // event.blob can be used to upload the cropped image
    }
  }
  imageLoaded(image: LoadedImage) {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
  doCrop() {
    this.cropper.crop();
  }
}
